export default {
    name:'load',
    data () {
        return {
            loadingtext:'加载'
        };
    },
    methods:{
        showLoading () {
            this.$Spin.show({
                render: (h) => {
                    return h('div', '正在'+this.loadingtext+',请耐心等待...');
                }
            });
        },
        hideLoading(){
            this.$Spin.hide();
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/base/load.js